import { createHttpLink } from "apollo-link-http";
import { setContext } from "@apollo/client/link/context";
import { getFullBearerToken } from "../../auth/tokens";

const httpEndpoint = () => {
  return process.env.VUE_APP_GRAPHQL_HTTP || "http://localhost:3000/graphql";
};

const createCustomHttpLink = () => {
  const baseHttpLink = createHttpLink({ uri: httpEndpoint() });

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        Authorization: getFullBearerToken(),
      },
    };
  });

  return authLink.concat(baseHttpLink);
};

export { createCustomHttpLink };
